// services/api.js
import axios from 'axios'

const API_URL = process.env.VUE_APP_BACKEND_API_URL

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 🚀 Interceptor to dynamically add the auth token to every request
apiClient.interceptors.request.use(
  (config) => {
    // Get token directly from localStorage to prevent circular dependency issues
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Token ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// ✨ Interceptor to handle auth errors (like expired tokens)
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // Existing logic to handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      window.location.href = '/access/login'
    }
    return Promise.reject(error)
  },
)

export default apiClient
